var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6976 2.28355C21.9745 2.55309 22.0713 2.958 21.9462 3.3236L15.4488 22.3236C15.3055 22.7429 14.9033 23.0178 14.4605 22.9991C14.0178 22.9805 13.6402 22.6727 13.5326 22.2429L11.1847 12.865L1.81005 11.051C1.37001 10.9658 1.04037 10.5983 1.00343 10.1516C0.966481 9.70493 1.23125 9.28823 1.65132 9.13194L20.6513 2.06279C21.0134 1.92806 21.4208 2.014 21.6976 2.28355ZM5.68755 9.76416L12.19 11.0224C12.5715 11.0962 12.8757 11.3844 12.9701 11.7613L14.6511 18.4755L19.371 4.67308L5.68755 9.76416Z",
    fill: "#141415"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5394 8.46867C15.9299 8.8592 15.9299 9.49236 15.5394 9.88289L12.711 12.7113C12.3205 13.1018 11.6873 13.1018 11.2968 12.7113C10.9063 12.3208 10.9063 11.6876 11.2968 11.2971L14.1252 8.46867C14.5157 8.07815 15.1489 8.07815 15.5394 8.46867Z",
    fill: "#141415"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.6bed55726959622cb93f2c3ed1d12b9f.svg";
export { ForwardRef as ReactComponent };